import { useTranslation } from 'react-i18next';

import Text from '~/components/Text';

import useGlobalModals from '../GlobalModals/hooks/useGlobalModals';

const LoginOrSubscribe = () => {
  const { t } = useTranslation();
  const { handleOpenModal } = useGlobalModals();

  return (
    <Text as="span" size="xs" type="body" theme="content" className="opacity-75">
      <button onClick={() => handleOpenModal('login')}>
        <span className="underline">{t('shared.cta.login')}</span>
      </button>{' '}
      {t('shared.cta.or')}{' '}
      <button onClick={() => handleOpenModal('signup')}>
        <span className="underline">{t('shared.cta.subscribe')}</span>
      </button>{' '}
      {t('shared.cta.to_participate')}.
    </Text>
  );
};

export default LoginOrSubscribe;
